import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'bootstrap';

import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { loadSongList } from './actions/songlist';
import createStoreAndDb from './store';

const { store, db } = createStoreAndDb();

// export const DbContext = React.createContext(db);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// Hot reloading
if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    ReactDOM.render(
      <Provider store={store}>
        <NextApp />
      </Provider>,
      document.getElementById('root'),
    );
  });
  window.store = store;
}

registerServiceWorker();

// store.dispatch(loadSongList(true));



// WEBPACK FOOTER //
// ./src/index.js